export default __webpack_public_path__ + "static/banner-c3b4a752cc12f37c8eb60f38116add1f.webp";